const Error = () => {
  return <div className="error">An error has occured!</div>;
};

export default Error;
